import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import TrainTheTrainer from "@/pages/TrainTheTrainer";
import OralChampion from "@/pages/OralChampion";
import Auth from "@/pages/Auth";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import SetPassword from "@/pages/SetPassword";
import ForgotPassword from "@/pages/ForgotPassword";
import Faq from "@/pages/Faq";
import VerifyCertificate from "@/pages/VerifyCertificate";
import InspectorView from "@/pages/InspectorView";

import DashboardShell from "@/pages/dashboard/Shell";
import DashboardHome from "@/pages/dashboard/Home";
import Courses from "@/pages/dashboard/Courses";
import CourseOverview from "@/pages/dashboard/CourseOverview";
import CoursePlayer from "@/pages/dashboard/CoursePlayer";
import TrainingReport from "@/pages/dashboard/TrainingReport";
import Certificates from "@/pages/dashboard/Certificates";
import LiveSessions from "@/pages/dashboard/LiveSessions";
import Resources from "@/pages/dashboard/Resources";
import Team from "@/pages/dashboard/Team";
import Billing from "@/pages/dashboard/Billing";
import Admin from "@/pages/dashboard/Admin";
import Profile from "@/pages/dashboard/Profile";
import DashboardFaq from "@/pages/dashboard/Faq";
import AdvisorWidget from "@/components/AdvisorWidget";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center bg-cream text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/train-the-trainer" element={<TrainTheTrainer />} />
            <Route path="/oral-champion" element={<OralChampion />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/signup" element={<Auth mode="signup" />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/verify" element={<VerifyCertificate />} />
            <Route path="/verify/:certNumber" element={<VerifyCertificate />} />
            <Route path="/inspector/:token" element={<InspectorView />} />

            <Route path="/app" element={<Protected><DashboardShell /></Protected>}>
              <Route index element={<DashboardHome />} />
              <Route path="courses" element={<Courses />} />
              <Route path="courses/:id" element={<CourseOverview />} />
              <Route path="courses/:id/learn" element={<CoursePlayer />} />
              <Route path="training-report" element={<TrainingReport />} />
              <Route path="certificates" element={<Certificates />} />
              <Route path="oral-champion" element={<LiveSessions />} />
              <Route path="live" element={<Navigate to="/app/oral-champion" replace />} />
              <Route path="resources" element={<Resources />} />
              <Route path="team" element={<Team />} />
              <Route path="billing" element={<Billing />} />
              <Route path="profile" element={<Profile />} />
              <Route path="admin" element={<Admin />} />
              <Route path="faq" element={<DashboardFaq />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <AdvisorWidget />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
